import Picture from './Picture';
export type { PictureProps } from './Pictures.type';

export default Picture;
